import instance from "./instance";
import { aanpAuthOptions } from "./util";
import { apiUrl } from "../config";

export function me() {
    return instance.get(`${apiUrl}/account/me`, aanpAuthOptions()).then(r => r.data);
}

export function validateContactId(contactId) {	
	 return instance.post(`${apiUrl}/account/validateContactId`, contactId, aanpAuthOptions()).then(r => r.data);
}